export class  UserContext {
    Username: string;
    SessionId: string;
    userId: string;
    ContractNumber: number
    securityUpdated: boolean;
    clientType: string;

    constructor(values: UserContext) {
        Object.assign(this, values);
      }
  }
